import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './ProgressIndicator.module.scss';
import { motion } from 'framer-motion';

const BimiProgressIndicator = ({ currentStep, validationFailed }) => {
  console.log('BimiProgressIndicator render:', { currentStep, validationFailed });

  const steps = [
    { label: 'Validate Logo', step: 1 },
    { label: 'Fix & Optimize', step: 2 },
    { label: 'Preview Result', step: 3 },
  ];

  const getStepStatus = (step) => {
    if (step === 1 && validationFailed) return 'failed';
    if (step < currentStep) return 'complete';
    if (step === currentStep) return 'current';
    return 'pending';
  };

  // Calculate progress line colors
  const getProgressLineStyle = () => {
    try {
      if (currentStep === 1) {
        return {
          backgroundColor: '#e5e7eb', // All gray
        };
      } else if (currentStep === 2) {
        return {
          backgroundImage: validationFailed
            ? 'linear-gradient(to right, #ff4d4f 50%, #e5e7eb 50%)'
            : 'linear-gradient(to right, #05c168 50%, #e5e7eb 50%)',
        };
      } else {
        // For step 3, show red for first half and green for second half if validation failed initially
        return validationFailed
          ? { backgroundImage: 'linear-gradient(to right, #ff4d4f 50%, #05c168 50%)' }
          : { backgroundColor: '#05c168' }; // All green if validation was successful from the start
      }
    } catch (error) {
      console.error('Error in getProgressLineStyle:', error);
      return { backgroundColor: '#e5e7eb' }; // Fallback to gray
    }
  };

  const lineStyle = getProgressLineStyle();
  console.log('Progress line style:', lineStyle);

  // Animation variants
  const circleVariants = {
    initial: { scale: 0.8, opacity: 1 },
    animate: { scale: 1, opacity: 1 },
    complete: {
      scale: [1, 1.1, 1],
      transition: { duration: 0.3 },
    },
  };

  return (
    <div className={styles.progressContainer}>
      <motion.div
        className={styles.progressLine}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        style={lineStyle}
      />

      {steps.map(({ label, step }) => {
        const status = getStepStatus(step);

        return (
          <motion.div
            key={step}
            className={styles.progressStep}
            initial="initial"
            animate={status === 'complete' || status === 'failed' ? 'complete' : 'animate'}
            variants={circleVariants}
          >
            <div className={`${styles.stepCircle} ${styles[status]}`}>
              {status === 'complete' ? (
                <CheckOutlined className={styles.checkIcon} />
              ) : status === 'failed' ? (
                <CloseOutlined className={styles.closeIcon} />
              ) : (
                <span className={styles.stepNumber}>{step}</span>
              )}
            </div>
            <span className={`${styles.stepLabel} ${styles[status]}`}>{label}</span>
          </motion.div>
        );
      })}
    </div>
  );
};

export default BimiProgressIndicator;
